module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/Notification.html -->\n<div class="middle-box text-center animated fadeInDown">\n    <a href="/">\n        <img src="/images/payrollpanda-logo.png" width="300">\n    </a>\n    <h3 class="font-bold"></h3>\n    <div>'+
((__t=( text ))==null?'':_.escape(__t))+
'</div>\n    ';
 if (loginLink) { 
__p+='\n        <div>Please <a href="/#login">Login</a></div>\n    ';
 } 
__p+='\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/Notification.html
// module id = 622
// module chunks = 1